<template>
  <div class="container py-md-5 px-md-3 text-body-secondary">
    <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-5">
      <template v-for="item in dataFooter" :key="item.id">
        <div class="col">
          <h5 v-if="item.url">
            <a :href="item.url" class="text-decoration-none text-body-emphasis text-dark">
              <img v-if="item.icon" :src="item.icon" width="32" height="32" class="me-2" />
              {{ item.name }}
            </a>
          </h5>
          <h5 v-else>{{ item.name }}</h5>
          <ul class="list-unstyled" v-if="item.children.length">
            <li v-for="child in item.children" :key="child.id" class="mb-2">
              <a v-if="child.url" :href="child.url" class="text-decoration-none d-flex align-items-center text-dark">
                <img v-if="child.icon" :src="child.icon" width="32" height="32" class="me-2" />
                <span>{{ child.name }}</span>
              </a>
              <span v-else class="d-flex align-items-center">
                <img v-if="child.icon" :src="child.icon" width="32" height="32" class="me-2" />
                <span>{{ child.name }}</span>
              </span>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import api from "@/api";

export default {
    name: 'CustomFooter',
    data() {
        return {
            loading: true,
            dataFooter: {},
            language: localStorage.getItem('language') || 'uz',
        };
    },
    methods: {
        async fetchFooter() {
            this.loading = true
            try {
                const { data } = await api.get(`/footer/`, {
                    headers: {
                        'Accept-Language': this.language,
                    },
                });
                this.dataFooter = data
            } catch (error){
                // Xatolikni e’tiborsiz qoldiramiz
            } finally {
                this.loading = false
            }
        }
    },
    mounted() {
        this.fetchFooter();
    },
}
</script>

<style></style>